export default __webpack_public_path__ + "static/media/pay_type_3.d884df1f.svg";